export default "__VITE_ASSET__9d8c7bb2__"